import React,{useRef,useEffect,useState} from "react";
import {AccordionView} from "vritra";
import ReactDOM from "react-dom/client";


export default React.memo(function Accordion(props){
    const {initiallyOpen,renderHeader,renderContent}=props;
    const state=useRef({
        parent:null,
        element:null,
        shadow:null,
    }).current;
    const [mounted,setMounted]=useState(false);
    useEffect(()=>{
        let {parent}=state;
        if(!parent){
            parent=state.parent=state.parentNode||document.body;
        }
        const {domref}=props;
        const element=AccordionView({
            ...props,parent,
            renderHeader:renderHeader&&(({parent})=>{
                const component=ReactDOM.createRoot(parent);
                component.render(renderHeader());
            }),
            renderContent:renderContent&&(({parent})=>{
                const component=ReactDOM.createRoot(parent);
                component.render(renderContent());
            }),
        });
        element.adjacentTo(state.shadow||state.element);
        state.element?.remove();
        state.element=element;
        if(initiallyOpen!==undefined){
            element.toggle(initiallyOpen);
        }
        if(domref){
            domref.current=element;
        }
        setMounted(true);
    },[]);
    /* useEffect(()=>{
        const {element}=state;
        
    },[]); */
    
    return mounted?React.createElement(React.Fragment):React.createElement("div",{
        ref:(element)=>{state.shadow=element},
        style:{display:"inline"},
    });
});
